import { lazy } from "react";

export const CouponPage = lazy(() => import("./couponPage"));
